import CAT_CONSTANTS from 'lookup/CatConstants';
import React, { useState } from 'react';
import DynamicSwitchOptionHeading from './DynamicSwitchOptionHeading';
import SingleDynamicSwitchOptionType from './SingleDynamicSwitchOptionType';

const DynamicSwitchOptions = ({ showDelta }) => {
  const [currentSort, setCurrentSort] = useState(CAT_CONSTANTS.dynamicSwitchGroupListSortValues[0]);
  const [hideInactive, setHideInactive] = useState(true && !showDelta);
  
  const handleSortChange = (sortOption) => {
    setCurrentSort(sortOption);
  }

  const handleInactiveFilter = (event) => {
    setHideInactive(!hideInactive);
  }

  const sortClassName = currentSort.value === CAT_CONSTANTS.dynamicSwitchGroupListSortConsts.SWITCH_TO_TARGET ? "dso-sort-class" : "";
  return (
    <>
      <DynamicSwitchOptionHeading
        handleSortChange={handleSortChange}
        handleInactiveFilter={showDelta ? null : handleInactiveFilter}
        hideInactive={hideInactive}
        currentSort={currentSort} />
      <div className={'dynamic-switch-options-list ' + sortClassName}>
        <SingleDynamicSwitchOptionType
          itemType={CAT_CONSTANTS.dynamicSwitchOptionTypeLabels.TARGET}
          hideInactive={hideInactive} />
        <SingleDynamicSwitchOptionType
          itemType={CAT_CONSTANTS.dynamicSwitchOptionTypeLabels.SWITCH}
          hideInactive={hideInactive} />
        <SingleDynamicSwitchOptionType
          itemType={CAT_CONSTANTS.dynamicSwitchOptionTypeLabels.AUXILIARY_DRUGS}
          hideInactive={hideInactive} />
      </div>
    </>
  )
}

export default DynamicSwitchOptions;